/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState } from 'react';
import { UserCardV1 } from '../../../../../../features/User/UserCard';
import { GetDate, GetTime } from '../../../../../../utils/Show';
import cn from '../../../../../../utils/cn';

function TableInfoCard({ name, value, isCapitalize, className }) {
    return (
        <div className={cn('flex justify-between items-center gap-3', className)}>
            <span className="text-primary opacity-50 font-normal w-fit min-w-[110px] text-sm capitalize">
                {name}
            </span>
            <span
                className={cn(
                    'value-text text-primary flex-1 w-full font-medium whitespace-break-spaces text-sm text-right break-words',
                    {
                        capitalize: isCapitalize
                    }
                )}
            >
                {value || '-----'}
            </span>
        </div>
    );
}

function TableRow({ item }) {
    const [isActive, setIsActive] = useState(false);

    const displayMembers = item.members?.map((i, index) => {
        if (index === item.members.length - 1) {
            // Last item, no comma needed
            return i?.fullName;
        }
        // Not the last item, add a comma
        return `${i?.fullName}, `;
    });

    return (
        <div
            tabIndex={-1}
            role="button"
            onClick={() => setIsActive(!isActive)}
            className={cn(
                `table-visible-data overflow-hidden w-full flex flex-col justify-between text-primary p-2.5 rounded-md transition-all duration-[800ms] ease-in-out remove-highlight`,
                {
                    'max-h-96': isActive,
                    'max-h-10': !isActive,
                    'placeholder-mode': item.demo
                }
            )}
        >
            <div className="w-full flex flex-row gap-1 justify-between text-primary text-sm font-medium leading-normal">
                <div className="min-w-[112px] w-28">
                    <span>{item?.id}</span>
                </div>
                <div className="w-full">
                    <span className="line-clamp-1">{item?.title}</span>
                </div>
                <div className="w-full hidden sm:block">
                    <span className="line-clamp-1">{item?.userInfo?.fullName}</span>
                </div>
            </div>

            <div className="table-data-more mt-3.5 flex flex-col justify-start items-item gap-2">
                <TableInfoCard
                    name="Activity By"
                    value={
                        <UserCardV1
                            hide
                            title={item?.userInfo?.fullName}
                            subTitle={item?.userInfo?.primaryEmail}
                            className="[&>div>h1]:!text-xs [&>div>p]:!text-[10px] [&>div]:text-right"
                        />
                    }
                />
                <TableInfoCard
                    name="Members"
                    value={item?.members?.length ? displayMembers : '---'}
                />
                <TableInfoCard name="Description" value={item?.description} />
                <TableInfoCard
                    name="Date Created"
                    value={
                        <span>
                            {GetDate(item?.timeCreated)}
                            <br />
                            <small>{GetTime(item?.timeCreated)}</small>
                        </span>
                    }
                />
            </div>
        </div>
    );
}

function TableMobile({ data }) {
    return (
        <div className="service_activity_mobile_table">
            <div className="table-data [&>*:nth-child(odd)]:bg-primary-50">
                {data && data?.length === 0 ? (
                    <div className="w-full text-sm font-medium p-2 rounded-5">
                        No Activity Found
                    </div>
                ) : (
                    data?.map((item) => <TableRow key={item.id} item={item} />)
                )}
            </div>
        </div>
    );
}

export default TableMobile;
